/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React from "react";
import AllReports from "../../../MiddleMileOperations/ExceptionReports/allReports";

const OdaDrsStatusUpdateAdoption = () => {
    const embeddedId = "eefa667c-240c-4680-b2e4-565a49880567";
    const role = JSON.parse(localStorage.getItem("userinfo"))?.roles?.[0];
    const hubDetails = JSON.parse(localStorage.getItem("userId"));
    const activeHub = JSON.parse(localStorage.getItem("active_hub"));

    let rsl = [];
    if (activeHub && activeHub.hubName) {
        rsl = [{ dataset: 1153, clause: `hub = '${activeHub.hubName}'` }];
    } else if (role === "ROLE_HUBADMIN") {
        rsl = [{ dataset: 1153, clause: `hub = '${hubDetails.premises.premiseName}'` }];
    }
    const title = "ODA Delivery Adoption";
    return (
        <div>
            <AllReports embeddedId={embeddedId} rsl={rsl} title={title} />
        </div>
    );
};

export default OdaDrsStatusUpdateAdoption;

